module.exports = __webpack_public_path__ + "img/my-bg.7804da65.png";